import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { BreadcrumbItemComponent } from 'src/app/components/breadcrumbs/breadcrumb-item/breadcrumb-item.component';
import { BreadcrumbsComponent } from 'src/app/components/breadcrumbs/breadcrumbs.component';
import { TabIndex } from 'src/app/components/tabs/tab-index.model';
import { TabComponent } from 'src/app/components/tabs/tab/tab.component';
import { TabsComponent } from 'src/app/components/tabs/tabs.component';
import { SummaryComponent } from './summary/summary.component';
import { DetailsComponent } from './details/details.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbsComponent,
    BreadcrumbItemComponent,
    TabsComponent,
    TabComponent,
    SummaryComponent,
    DetailsComponent,
  ],
})
export class HomeComponent {
  public onTabClick(tabIndex: TabIndex): void {
    this.tabSelected.update(() => tabIndex);
  }

  public tabSelected = signal<TabIndex>('summary');
}
